"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../styles");
var Product_1 = __importDefault(require("./Product"));
var PopupForm_1 = __importStar(require("../../../common/PopupForm"));
function Products(props) {
    var _a = (0, react_1.useState)(8), productSlice = _a[0], setProductSlice = _a[1];
    var _b = (0, react_1.useState)(false), popupOpen = _b[0], setPopupOpen = _b[1];
    return (react_1.default.createElement(styles_1.Section, { className: props.className },
        react_1.default.createElement(styles_1.SectionTitle, null, props.title),
        react_1.default.createElement("div", { className: "productList" }, props.products.slice(0, productSlice).map(function (product, i) { return (react_1.default.createElement(Product_1.default, { key: i, href: product.link, onClick: function () {
                !product.link && setPopupOpen(true);
            } },
            react_1.default.createElement("img", { src: product.image }),
            react_1.default.createElement(styles_1.LabelTitle, null, product.text))); })),
        react_1.default.createElement(styles_1.CenterContainer, null, productSlice === 8 && props.products.length > 8 && (react_1.default.createElement(styles_1.Button, { onClick: function () { return setProductSlice(props.products.length); } }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0435"))),
        react_1.default.createElement(PopupForm_1.default, { authToken: props.authToken, open: popupOpen, onClose: function () {
                setPopupOpen(false);
            }, siteKey: props.siteKey, formName: PopupForm_1.B2B_CTA_FORM, requestName: "/sample_order_requests", title: "\u041E\u0421\u0422\u0410\u0412\u0418\u0422\u042C \u0417\u0410\u042F\u0412\u041A\u0423", btnTitle: "\u041E\u0421\u0422\u0410\u0412\u0418\u0422\u042C \u0417\u0410\u042F\u0412\u041A\u0423" })));
}
var StyledProducts = (0, styled_components_1.default)(Products)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .productList {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n\n  ", " {\n    cursor: pointer;\n  }\n\n  ", " {\n    margin-top: auto;\n  }\n"], ["\n  .productList {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n\n  ", " {\n    cursor: pointer;\n  }\n\n  ", " {\n    margin-top: auto;\n  }\n"])), Product_1.default, styles_1.LabelTitle);
exports.default = StyledProducts;
var templateObject_1;
